import { fetcher } from "helpers/fetcher";

import {
  TGetActiveVacancySlotDetailsReq,
  TGetActiveVacancySlotDetailsRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getActiveVacancySlotDetails = async (
  params: TGetActiveVacancySlotDetailsReq
) => {
  return await fetcher<
    TGetActiveVacancySlotDetailsRes,
    TGetActiveVacancySlotDetailsReq
  >(ENDPOINT.CORPORATION.GET_ACTIVE_VACANCIES_SLOT_DETAILS, {
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.GET_ACTIVE_VACANCIES_SLOT_DETAILS.version,
      [API_HEADER.CORP_ID]: params?.idCorporation,
      [API_HEADER.BU_ID]: params?.idBusinessUnit,
    },
  });
};

export const queryGetActiveVacancySlotDetails = async (
  params: TGetActiveVacancySlotDetailsReq
) => {
  return (await getActiveVacancySlotDetails(params)).data;
};

queryGetActiveVacancySlotDetails._key = (
  params: TGetActiveVacancySlotDetailsReq,
  key?: string
) => [ENDPOINT.CORPORATION.GET_ACTIVE_VACANCIES_SLOT_DETAILS.url, params, key];
